import React, { useState , useEffect } from "react";
import { toast, Toaster } from 'react-hot-toast';

import { Fragment } from 'react';

import { Link, useParams } from 'react-router-dom/cjs/react-router-dom';
import SendWhiteIcon from '../../../../../_asset/img/send-white_icon.svg';
import Document from '../../../../../_asset/img/docu.svg';
import Paperclip from '../../../../../_asset/img/paperclip-2.png';
import InfoCircle from '../../../../../_asset/img/info-circle.svg';
import TimerStart from '../../../../../_asset/img/timer-start.svg';
import { ReactComponent as Profile } from '../../../../../_asset/img/profile.svg';

import { postJobComment , getCommentsForJob , getTeamManagers , assignJob } from "../../../../../../services/staffingService";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";


const schema = yup
  .object({
    comment: yup
      .string()
      .required("comment is required")
      .max(3200, "Max length exceeded"),
  })
.required();


const SideDrawer = ({ job, isOpen, setIsOpen, getByItem }) => {
    const { providerCompanyId } = useParams();

    const [comments, setComments] = useState([]);
    const [selectedManager, setSelectedManager] = useState(null);
    const [showSaveButton, setShowSaveButton] = useState(false);
    const [dispatchManagers, setDispatchManagers] = useState([]);
    const [countdown, setCountdown] = useState(5);

    // const data = ['Eugenia', 'Bryan', 'Linda', 'Nancy', 'Lloyd', 'Alice', 'Julia', 'Albert'].map(
    //     item => ({ label: item, value: item })  
    // );
    
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(schema),
    });

    const onSubmit = async (data) => {
        await postJobComment(providerCompanyId , job._id, data.comment);
        const resp = await getCommentsForJob(providerCompanyId, job._id);
        setComments([...resp.data.comments]);
        reset();
    }

    useEffect(() => {
        fetchComments();
        fetchProviderManagers();
    }, [job]);

    async function fetchComments() {
        const resp = await getCommentsForJob(providerCompanyId, job._id);
        setComments([...resp.data.comments]);
    }

    async function fetchProviderManagers() {
        const resp = await getTeamManagers(providerCompanyId);

        const formattedData = resp.data.providerManagers
          .filter(item => item.user_id !== null) // Filter out managers with null user_id
          .map(item => ({
            label: `${item.user_id.firstName} ${item.user_id.lastName}`,
            value: item
          }));
        setDispatchManagers(formattedData);
    }


    const handleSelectManager = (value) => {
        setSelectedManager(value);
        setShowSaveButton(true); 
    };

    const handleSave = async () => {

        if (selectedManager) {
            await assignJob(providerCompanyId, job._id, selectedManager._id);
            setShowSaveButton(false); 

            // Show single toast with 5 second duration - no countdown updates
            toast.success('Dispatch Manager assigned. Refreshing page in 5 seconds...', {
                duration: 5000
            });
        
            // Simple timeout to refresh page after 5 seconds
            setTimeout(() => {
                window.location.reload();
            }, 5000);
        }

    };
    

    const handleClearManager = () => {
        setSelectedManager(null);
        setShowSaveButton(false); 
    };


    return (
      <>
        <Toaster />
        {/* Drawer Overlay */}
        {isOpen && (
          <div className="fixed inset-0 z-50 overflow-hidden">
            {/* Background Overlay */}
            <div 
              className="absolute inset-0 bg-black bg-opacity-50" 
              onClick={() => setIsOpen(false)}
            />
            
            {/* Drawer Panel - Exact 856px width with Inter font */}
            <div className="absolute right-0 top-0 h-full bg-white shadow-xl transform transition-transform duration-300 ease-in-out" 
                 style={{ width: '856px', fontFamily: 'Inter' }}>
              {/* Close Button - Exact positioning and styling */}
              <button 
                onClick={() => setIsOpen(false)}
                className="absolute flex items-center justify-center w-8 h-8 bg-white border border-black rounded-lg"
                style={{ 
                  top: '24px', 
                  left: '-15px',
                  boxShadow: '0px 8px 24px 0px rgba(0, 0, 0, 0.09)'
                }}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              
              {/* Drawer Content */}
              <div className="flex h-full">
                {/* Left Bar */}
                <div className="border-r border-[#E4E4E4]" style={{ width: 'calc(100% - 296px)' }}>
                  {/* Title Section */}
                  <div className="px-6 pt-6 pb-2 border-b border-[#E4E4E4]">
                    <h1 className="text-2xl font-bold text-black leading-8 m-0">
                      {job?.isLead 
                        ? job?.contact?.name || "Unknown Contact"
                        : job.customer_company_id?.companyLegalName || "Unknown Company"
                      }
                    </h1>
                  </div>
                  
                  {/* Scrollable Content */}
                  <div className="px-6 py-6 overflow-y-auto" style={{ height: 'calc(100vh - 65px)' }}>
                    
                    {/* Memo Section */}
                    <div className="mb-4">
                      <h4 className="text-xs font-medium text-[#616161] mb-1">MEMO</h4>
                      <p className="text-sm font-normal text-black m-0">{job.memo || "..."}</p>
                    </div>
                    
                    {/* Time Amount Card */}
                    <div className="rounded-lg p-4 mb-4" style={{ backgroundColor: '#FBF2F6' }}>
                      <div className="text-base font-semibold text-black mb-0.5">${job.hourlyPayRate}/hrs</div>
                      <p className="text-xs font-normal text-[#878787] m-0">Max. Hourly Rate</p>
                    </div>
                    
                    {/* Shifts Card */}
                    <div className="rounded-lg p-4 mb-4" style={{ backgroundColor: '#F7F8FA' }}>
                      <div className="text-base font-semibold text-black mb-4">Shifts</div>
                      <table className="w-full">
                        <thead>
                          <tr>
                            <th className="pr-4 pb-4 border-0 text-left text-xs font-medium text-black">Shift Date</th>
                            <th className="pr-4 pb-4 border-0 text-left text-xs font-medium text-black">Shift Times</th>
                            <th className="pr-4 pb-4 border-0 text-left text-xs font-medium text-black">Officers Required</th>
                          </tr>
                        </thead>
                        <tbody>
                          {job?.shifts?.map((shift) => (
                            <tr key={shift._id}>
                              <td className="pr-4 py-4 border-t border-[#E4E4E4] text-xs font-medium text-[#878787]">
                                {new Date(shift.date).toLocaleDateString()}
                              </td>
                              <td className="pr-4 py-4 border-t border-[#E4E4E4] text-xs font-medium text-[#878787]">
                                {`${new Date(shift.startTime).toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })} to ${new Date(shift.endTime).toLocaleTimeString([], { 
                                  hour: "2-digit", 
                                  minute: "2-digit" 
                                })} Hrs`}
                              </td>
                              <td className="pr-4 py-4 border-t border-[#E4E4E4] text-xs font-medium text-[#878787]">
                                {shift.staffsRequired}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    
                    {/* Offer Card */}
                    <div className="rounded-lg p-4 mb-4" style={{ backgroundColor: '#F7F8FA' }}>
                      <div className="text-base font-semibold text-black mb-4">Offer Statistics</div>
                      <div className="space-y-0">
                        <div className="py-2 border-b border-[#E4E4E4] flex gap-2 items-center">
                          <p className="text-xs font-normal text-[#878787] m-0 h-auto w-[150px]">Recommendations</p>
                          <div className="text-xs font-medium text-black m-0" style={{ width: 'calc(100% - 158px)' }}>
                            {job.totalRecommendations}
                          </div>
                        </div>
                        <div className="py-2 border-b border-[#E4E4E4] flex gap-2 items-center">
                          <p className="text-xs font-normal text-[#878787] m-0 h-auto w-[150px]">Shift Coverage</p>
                          <div className="text-xs font-medium text-black m-0" style={{ width: 'calc(100% - 158px)' }}>
                            {job?.statistics?.overallCoverage?.toFixed(2) || 0} %
                          </div>
                        </div>
                        <div className="py-2 flex gap-2 items-center">
                          <p className="text-xs font-normal text-[#878787] m-0 h-auto w-[150px]">Offers</p>
                          <div className="text-xs font-medium text-black m-0 flex items-center gap-4" style={{ width: 'calc(100% - 158px)' }}>
                            {/* Steps-like display */}
                            <div className="flex items-center gap-2">
                              <div className="relative w-5 h-5 rounded-full flex items-center justify-center text-white text-[10px] font-medium" 
                                   style={{ backgroundColor: '#404880' }}>
                                {job?.statistics?.offerCounts?.open || 0}
                              </div>
                              <span className="text-xs font-medium text-black">Open</span>
                            </div>
                            <div className="flex items-center gap-2">
                              <div className="relative w-5 h-5 rounded-full flex items-center justify-center text-white text-[10px] font-medium" 
                                   style={{ backgroundColor: '#B6B9CF' }}>
                                {job?.statistics?.offerCounts?.accepted || 0}
                              </div>
                              <span className="text-xs font-medium text-black">Accepted</span>
                            </div>
                            <div className="flex items-center gap-2">
                              <div className="relative w-5 h-5 rounded-full flex items-center justify-center text-white text-[10px] font-medium" 
                                   style={{ backgroundColor: '#B6B9CF' }}>
                                {job?.statistics?.offerCounts?.rejected || 0}
                              </div>
                              <span className="text-xs font-medium text-black">Rejected</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Comments Section - Timeline Style */}
                    <div className="mb-6">
                      {comments.length >= 1 &&
                        comments.map((comment, index) => (
                          <div key={comment._id} className="mb-6 relative">
                            {/* Icon wrapper */}
                            <div className="flex items-start gap-3">
                              <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0" 
                                   style={{ backgroundColor: '#404880' }}>
                                {comment.provider_manager_id?.user_id?.profilePictureUrl ? (
                                  <img
                                    className="w-6 h-6 rounded-full object-cover"
                                    src={comment.provider_manager_id.user_id.profilePictureUrl}
                                    alt="Profile"
                                  />
                                ) : (
                                  <Profile className="w-3 h-3 text-white" />
                                )}
                              </div>
                              <div className="flex-1">
                                {/* Comment Title */}
                                <div className="flex items-center gap-2 mb-2">
                                  <h4 className="text-sm font-medium text-black p-0 m-0">
                                    {comment.provider_manager_id &&
                                    comment.provider_manager_id.user_id
                                      ? `${comment.provider_manager_id.user_id.firstName} ${comment.provider_manager_id.user_id.lastName}`
                                      : "Unknown Manager"}
                                  </h4>
                                  <ul className="flex gap-7 flex-wrap m-0 pl-5 list-none">
                                    <li className="text-[10px] font-normal text-[#878787] leading-5">
                                      {new Date(comment.createdAt).toLocaleDateString()}
                                    </li>
                                  </ul>
                                </div>
                                {/* Comment Description */}
                                <p className="text-xs font-normal text-[#404040] mb-2">{comment.text}</p>
                                {/* Document attachment */}
                                {comment.attachmentUrl && (
                                  <div className="inline-flex items-center justify-center gap-2 rounded-full border border-[#E4E4E4] text-xs font-normal text-black px-2 py-1.5" 
                                       style={{ backgroundColor: '#F7F8FA' }}>
                                    <img src={Document} alt="Document Icon" className="w-3 h-3" />
                                    {comment.attachmentUrl}
                                  </div>
                                )}
                              </div>
                            </div>
                            {/* Timeline tail */}
                            {index !== comments.length - 1 && (
                              <div className="absolute left-3 top-6 w-0.5 h-6 border-l border-[#E4E4E4]"></div>
                            )}
                          </div>
                        ))}
                    </div>

                    {/* Send Comment Form */}
                    <div className="rounded-lg border border-[#E4E4E4] p-4" style={{ backgroundColor: '#F5F5F5' }}>
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-group mb-2">
                          <textarea
                            rows={3}
                            placeholder="add logs or comments"
                            {...register("comment")}
                            className="form-textarea bg-transparent border-none"
                          />
                          {errors.comment && (
                            <div className="form-error">
                              {errors.comment.message}
                            </div>
                          )}
                        </div>
                        <div className="flex items-center justify-between mt-2">
                          <div className="flex items-center gap-2">
                            <img src={Paperclip} alt="Attach" className="w-4 h-4 cursor-pointer" />
                          </div>
                          <button 
                            type="submit"
                            className="text-white text-xs font-normal px-2 py-2 rounded-lg transition-colors hover:opacity-80"
                            style={{ backgroundColor: '#9E9E9E' }}
                          >
                            Comment
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                
                {/* Right Bar - Exact 296px width */}
                <div className="w-[296px] p-6 h-screen overflow-y-auto flex flex-col justify-between">
                  <div>
                    {/* Assignment Title */}
                    <h2 className="text-base font-semibold text-black pb-4 border-b border-[#E4E4E4] leading-6 mb-4">
                      Job Assignment
                    </h2>
                    
                    {/* Data Card - Current Manager */}
                    <div className="mb-6">
                      <p className="text-xs font-normal text-[#616161] mb-2">Assigned Dispatch Manager:</p>
                      <div className="flex items-center gap-2 mb-4">
                        <h2 className="text-xs font-medium text-black">
                          {job?.provider_manager_id?.user_id?.firstName || "Unassigned"}{" "}
                          {job?.provider_manager_id?.user_id?.lastName || ""}
                        </h2>
                        <img src={InfoCircle} alt="Information" className="w-4 h-4" />
                      </div>
                      
                      <label className="form-label">
                        Reassign Dispatch Manager:
                      </label>
                      
                      {/* Custom Select Picker Style */}
                      <div className="form-group">
                        <select 
                          onChange={(e) => {
                            const selectedManager = dispatchManagers.find(m => m.value._id === e.target.value);
                            if (selectedManager) {
                              handleSelectManager(selectedManager.value);
                            }
                          }}
                          className="form-select border-[#D9BA61] text-base font-semibold"
                          style={{ 
                            backgroundColor: '#FFFCF5',
                            color: '#D9BA61'
                          }}
                        >
                          <option value="">Select Manager</option>
                          {dispatchManagers.map((manager, index) => (
                            <option key={index} value={manager.value._id}>
                              {manager.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      
                      {showSaveButton && (
                        <button
                          onClick={handleSave}
                          className="rounded-lg px-2 py-1 text-white text-xs font-normal"
                          style={{ backgroundColor: '#9E9E9E' }}
                        >
                          Save
                        </button>
                      )}
                    </div>

                    {/* Other Data Cards */}
                    <div className="mb-4">
                      <p className="text-xs font-normal text-[#616161] mb-2">Job ID</p>
                      <h2 className="text-xs font-medium text-black">
                        #{job._id}
                      </h2>
                    </div>

                    <div className="mb-4">
                      <p className="text-xs font-normal text-[#616161] mb-2">Location</p>
                      <h2 className="text-xs font-medium text-black">
                        {job.location}
                      </h2>
                    </div>

                    <div className="mb-4">
                      <p className="text-xs font-normal text-[#616161] mb-2">Service Type</p>
                      <h2 className="text-xs font-medium text-black">
                        {job.service
                          .split("_")
                          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                          .join(" ")}
                      </h2>
                    </div>

                    {/* Impact Section */}
                    <div className="mb-6">
                      <div className="flex items-center gap-2 mb-4">
                        <p className="text-xs font-normal text-[#616161] m-0 w-1/2">Revenue:</p>
                        <div className="w-1/2">
                          <div className="rounded-lg text-center text-xs font-medium px-1 py-1 w-full flex items-center justify-center"
                               style={{ backgroundColor: '#FAE0E0', color: '#EC605A' }}>
                            <span className="block text-center w-full">High</span>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 mb-4">
                        <p className="text-xs font-normal text-[#616161] m-0 w-1/2">Priority:</p>
                        <div className="w-1/2">
                          <div className="rounded-lg text-center text-xs font-medium px-1 py-1 w-full flex items-center justify-center"
                               style={{ backgroundColor: '#CCE1D1', color: '#82B376' }}>
                            <span className="block text-center w-full">Low</span>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 mb-4">
                        <p className="text-xs font-normal text-[#616161] m-0 w-1/2">Urgency:</p>
                        <div className="w-1/2">
                          <div className="rounded-lg text-center text-xs font-medium px-1 py-1 w-full flex items-center justify-center"
                               style={{ backgroundColor: '#FBE7D2', color: '#F2A366' }}>
                            <span className="block text-center w-full">Medium</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Send Offer Button - Bottom */}
                  <div className="send_offer">
                    <Link
                      to={`/provider-company/${providerCompanyId}/jobs/${getByItem?._id}`}
                      className="w-full rounded-lg px-3 py-3 text-white text-base font-semibold leading-6 flex items-center justify-between gap-2 no-underline"
                      style={{ backgroundColor: '#404880' }}
                    >
                      <div className="flex items-center gap-4">
                        <span>Shift Offers</span>
                        <div className="opacity-16 bg-white w-px h-4"></div>
                      </div>
                      <img src={SendWhiteIcon} alt="" className="w-4 h-4" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </> 
    );
}

export default React.memo(SideDrawer);